import { useFormContext } from "react-hook-form";
import { ErrorMessage, TextInput, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { SignUpClientFormData, SignUpDriverFormData, SignUpInviteFormData, SignUpOperatorFormData } from "../types";

export const FirstNameField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<SignUpDriverFormData | SignUpOperatorFormData | SignUpClientFormData | SignUpInviteFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography variant="paragraph">First Name</Typography>
      <TextInput
        className="w-full"
        hasError={!!errors.firstName}
        placeholder="Enter Your First Name"
        maxLength={45}
        {...register("firstName")}
      />
      <ErrorMessage errors={errors} name="firstName" />
    </div>
  );
};
